import type { PropsWithChildren } from 'react'
import { space } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'

import { ActiveStepProvider } from './context'
import { Step } from './Step'

interface StepsProps {
  activeStepValue?: string
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  counter-reset: stepsnumber;

  > * {
    margin-bottom: ${space('primitives_space_16')};

    &:last-child {
      margin-bottom: initial;
    }
  }
`

export function Steps({ children, activeStepValue }: PropsWithChildren<StepsProps>) {
  return (
    <Wrapper>
      <ActiveStepProvider value={activeStepValue}>{children}</ActiveStepProvider>
    </Wrapper>
  )
}

Steps.Step = Step
